import { Component, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar-footer',
  templateUrl: './sidebar-footer.component.html',
  styleUrls: ['./sidebar-footer.component.scss'],
})
export class SidebarFooterComponent implements OnInit {
  // appPreviewChangelogUrl: string = environment.appPreviewChangelogUrl;

  APP_VERSION = environment.appVersion;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  onClickAdminCms() {
    this.router.navigate(['/admin-cms']).then();
  }
}
